import { CampaignStatus, type Campaign } from '../';
import { canonicalizeCampaignDate, getCampaignPeriodDateErrors } from './campaign-dates';

type ResolveCampaignStartDateUpdateArgs = {
  campaign: Pick<Campaign, 'start_date' | 'status'>;
  nextStartDate?: string;
  workspaceTimezone?: string;
};

export function resolveCampaignStartDateUpdate({
  campaign,
  nextStartDate,
  workspaceTimezone,
}: ResolveCampaignStartDateUpdateArgs) {
  if (!nextStartDate) return campaign.start_date;

  const currentStartDate = canonicalizeCampaignDate(campaign.start_date, workspaceTimezone);
  const normalizedNextStartDate = canonicalizeCampaignDate(nextStartDate, workspaceTimezone);

  if (normalizedNextStartDate === currentStartDate) {
    return currentStartDate;
  }

  if (campaign.status !== CampaignStatus.SCHEDULED) {
    throw new Error('Campaign start date can only be updated while the campaign is scheduled.');
  }

  const startDateError = getCampaignPeriodDateErrors({
    campaignStartDate: normalizedNextStartDate,
    hasEndDate: false,
    workspaceTimezone,
  }).startDate;

  if (startDateError) {
    throw new Error('Campaign start date must be today or within the next 30 days.');
  }

  return normalizedNextStartDate;
}
